/* eslint-disable react-hooks/exhaustive-deps */
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useEffect, useState } from "react";
import api, { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { LogoSolar } from "src/framework/components/commons/LogoSolar";
import { NavLink } from "react-router-dom";
import ExternalLink from "../../commons/ExternalLink";
import { useObservable } from "src/framework/store/storeUtil";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import jwtDecode from "jwt-decode";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import jwt from 'jwt-simple';
import { IMenuItem } from "src/framework/store/AppStore";
import { JwtMenu } from "src/framework/store/LoginStore1";
import { MenuItem } from "../MenuItem";
import { mobileWidth } from "src/framework/layouts/Main";
import { menuActived$, openMenu$ } from "src/framework/store/ApiEvents";

const getUrlLoja = (segmento: string, venda: 'gerador' | 'avulso') => {
  const _tokenApi = LocalStorage.get("solar.token");
  if (!process.env.REACT_APP_TOKEN_KEY) return;

  if (_tokenApi) {
      const decoded: any = jwtDecode(_tokenApi);
      const _tokenLoja = {
          cnpj_cpf: decoded.user.cnpjCpf,
          token: decoded.token,
          refresh_token: decoded.refreshToken,
          type: decoded.type,
          customContaUnica: decoded.customContaUnica
      }
      const tLoja = jwt.encode(_tokenLoja, process.env.REACT_APP_TOKEN_KEY)
      let _url = `${encodeURIComponent("/")}&token=${tLoja}`;

      if (!!segmento) {
        _url += `&segmento=${segmento}`;
      }
      
      if (!!venda) {
        _url += `&venda=${venda}`
      }

      return `${process.env.REACT_APP_URL_LOJA}?${_url}`;
  }
}

const Menu = ({ classes }: { classes: any }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const defaultWidth = isMobile ? mobileWidth : 288;

  const [menuState, setMenuState] = useState<IMenuItem[]>([]);
  const [menuWidth, setMenuWidth] = useState<number>(isMobile ? defaultWidth : 288);
  const [logoWidth, setLogoWidth] = useState<number>(200);
  const openMenu = useObservable(openMenu$);
  const menuActived = useObservable(menuActived$);
  const [linkList, setLinkList] = useState<string[]>([]);

  const extractLinks = async (menu: IMenuItem[]): Promise<string[]> => {
    const links: string[] = [];

    for (const item of menu){
      if (item.link) {
        links.push(item.link);
      }
  
      if (item.menuItem && item.menuItem.length > 0) {
        links.push(...(await extractLinks(item.menuItem)));
      }
    }
    return links;
  }

  useEffect(() => {
    const menuUrlsOnGrid = ['dimensionado', 'personalizado', 'kit_ongrid', 'vertical'].map(item => `/projetos?tipo=${item}`)
    const menuUrlsOffGrid = ['dimensionado_offgrid', 'kit_offgrid', 'personalizado_offgrid',].map(item => `/projetos?tipo=${item}`)
    const menuUrlsHibrido = ['dimensionado_hibrido', "personalizado_hibrido"].map(item => `/projetos?tipo=${item}`)

    api.get({ url: "/menu/usuario" })
      .then((response: IDataResponse) => {
        if (response.statusCode === STATUS_CODE.OK) {
          const menus = response.data.map((rec: JwtMenu) => {
            const subMenusOnGrid = (rec.menu || [])?.filter((item: JwtMenu) => menuUrlsOnGrid.includes(item.url || ""));
            const subMenusOffGrid = (rec.menu || [])?.filter((item: JwtMenu) => menuUrlsOffGrid.includes(item.url || ""));
            const subMenusHibrido = (rec.menu || [])?.filter((item: JwtMenu) => menuUrlsHibrido.includes(item.url || ""));

            let novoSubMenus = rec.menu || []

            if (subMenusOnGrid.length > 0) {
              novoSubMenus = novoSubMenus.filter((item => !menuUrlsOnGrid.includes(item.url || "")));

              novoSubMenus.push(
                {
                  nome: "On Grid",
                  icone: '',
                  url: '',
                  separador: true
                },
                ...subMenusOnGrid
              );
            }

            if (subMenusHibrido.length > 0) {
              novoSubMenus = novoSubMenus.filter((item => !menuUrlsHibrido.includes(item.url || "")));

              novoSubMenus.push(
                {
                  nome: "Híbrido",
                  icone: '',
                  url: '',
                  separador: true
                },
                ...subMenusHibrido
              );
            }

            if (subMenusOffGrid.length > 0) {
              novoSubMenus = novoSubMenus.filter((item => !menuUrlsOffGrid.includes(item.url || "")));

              novoSubMenus.push(
                {
                  nome: "Off Grid",
                  icone: '',
                  url: '',
                  separador: true
                },
                ...subMenusOffGrid
              );
            }

            const result: IMenuItem = {
              text: rec.nome,
              icon: (rec.icone || 'star'),
              isSubItem: false,
              link: (rec.url || null),
              menuItem: novoSubMenus?.map((filho: JwtMenu) => {
                const lojaLinkExterno = ["/projetos?tipo=kit_ongrid", "/projetos?tipo=kit_offgrid", "/projetos?tipo=loja_avulso"].includes(filho.url || "");
                const targetLinkExterno = lojaLinkExterno ? "_self" : "_blank";

                if (lojaLinkExterno) {
                  let segmento = filho.url?.includes("kit_ongrid") ? "on" : "off";
                  const venda = filho.url?.includes("loja_avulso") ? "avulso" : "gerador"

                  if (venda === 'avulso') { 
                    segmento = ''
                  }

                  filho.url = getUrlLoja(segmento, venda);
                }

                const result: IMenuItem = {
                  text: filho.nome,
                  icon: (filho.icone || null),
                  isSubItem: true,
                  link: (filho.url || null),
                  isExternalLink: lojaLinkExterno,
                  targetLink: targetLinkExterno,
                  isSeparator: filho.separador || false,
                  diasTag: filho?.dias_tag,
                  dataTag: filho?.data_tag,
                }

                return result;
              })
            }

            return result;
          });
          setMenuState(menus);
        }
      })
  }, []);

  useEffect(() => {
    const delay = !openMenu ? 300 : 0;
    if (menuState?.length) {
      setTimeout(() => {
        setLogoWidth(openMenu ? 200 : 0);
        setMenuWidth(openMenu ? defaultWidth : 73);
      }, delay); 
    }
  }, [menuState, openMenu]);

  useEffect(()=>{
    if(menuState && menuState.length>0){
      const fetchLinks = async () => {
        return await extractLinks(menuState);
      }
      fetchLinks().then((links)=>{
        setLinkList(links);
      })
    }
  },[menuState])
  
  return (
    <div className={classes.drawerContainer}>
      <div className={classes.menuBox}>
        <NavLink to={"/"}>
            <LogoSolar
              fillIntelbras={"#00B26B"}
              width={`${logoWidth}`}
            />
        </NavLink>
      </div>
      <Scrollbars key={"scrollbar-menu"} style={{ width: menuWidth, height: "calc(100vh - 64px - 72px - 40.03px - 20px)" }}>
        <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "calc(100% - 40px)" }}>
          <Box>
            <List>
              {menuState.map((menuItem, index) => (
                <MenuItem
                  index={index}
                  nested={false}
                  menuItem={menuItem}
                  current={menuActived}
                  key={`menu-menu-${index}`}
                  setCurrent={(index: number) => {
                    menuActived$.next(index);
                  }}
                  linkList={linkList}
                />
              ))}
              <div style={{ marginBottom: 48 }} />
            </List>
          </Box>
        </Box>
      </Scrollbars>
      <section className={classes.menuFooter}>
        <header className={classes.menuFooterContent}>
          <Divider />
        </header>
        <footer>
          { openMenu ? (
            <ExternalLink
              label="visite nosso site"
              text="www.intelbras.com.br"
              url="https://www.intelbras.com.br"
              styleContent={{ padding: 20, textAlign: "center" }}
              styleLink={{ color: "#007225" }}
            />
          ) : <></>
          }
        </footer>
      </section>
    </div>
  );
};
export { Menu };
